import {AxiosInstance} from "axios";

export default class SidebarOrderApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	fetchJobSidebarOrder(): Promise<string[]> {
		const url = `/api/web/jobs/properties`;
		return this.axiosInstance.get(url).then(resp => resp.data)
	}

	/**
	 * Update job sidebar sort order.
	 * @param {string[]} sidebarOrder
	 */
	updateJobSidebarOrder(sidebarOrder: string[]) {
		const url = `/api/web/jobs/properties/order`;
		return this.axiosInstance.put(url, sidebarOrder);
	}

	fetchLeadSidebarOrder(): Promise<string[]> {
		const url = `/api/web/leads/properties`;
		return this.axiosInstance.get(url).then(resp => resp.data)
	}

	/**
	 * Update lead sidebar sort order.
	 * @param {string[]} sidebarOrder
	 */
	updateLeadSidebarOrder(sidebarOrder: string[]) {
		const url = `/api/web/leads/properties/order`;
		return this.axiosInstance.put(url, sidebarOrder);
	}
}